/**
 * [ File :: G_VariableReal.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/attr/G_VariableReal.js
 * @목적 : 그리드 타입에서 활용하는 값만 가지고 있는 변수 객체
 * @진행 : 진행 중
 * @주의 :
 * @이슈 :
 * @일자 : 2018.08.17
 * @작성 : Lee Mi Reu
 * @참조 :
 */

import MixinBuilder from '../../scripts/MixinBuilder';
import B_Unreal from '../base/B_Unreal';
import B_ChildWorld from '../base/B_ChildWorld';
import B_Util from '../../util/B_Util';

const mix = superclass => new MixinBuilder(superclass);

const init = () => {
    return class B_VariableReal extends mix(B_Unreal).with(B_ChildWorld) {
        constructor(obj) {
            super(obj);

            if (typeof obj.value !== 'undefined') this._value = obj.value;
            if (typeof obj.min !== 'undefined') this._min = obj.min;
            if (typeof obj.max !== 'undefined') this._max = obj.max;

            this.isFail = false;

            return B_Util.getProtected(this);
        }

        // 게터/세터가 작동을 안 하는 JS 인터프리터에서 사용하기 위한 함수
        getValue() {
            return this.value;
        }

        setValue(value) {
            this.value = value;
        }

        plusValue(value) {
            this.value = Number((Number(this._value) + Number(value)).toFixed(12));
            return this.isFail;
        }

        minusValue(value) {
            this.value -= value;
        }

        get value() { return this._value; }

        set value(value) {
            // 최소값 / 최대값 처리
            if (this._min !== null && this._min > value) this._value = this._min;
            else if (this._max !== null && this._max < value) this._value = this._max;
            else this._value = value;
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/attr/B_VariableReal.js